/*
 * @Description: 筛选有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  今天: '今天',
  昨天: '昨天',
  天: '天',
  自定义: '自定义',
  本年度: '本年度',
  上一年: '上一年',
  本季度: '本季度',
  上一季度: '上一季度',
  本月: '本月',
  上月: '上月',
  本周: '本周',
  上周: '上周',
  缺少参数: '缺少参数',
  仅看我的: '仅看我的',
  部门: '部门',
  用户: '用户',
  人员: '人员',
  组织机构: '组织机构',
  关闭搜索: '关闭搜索',
  组织架构: '组织架构',
  智书企飞: '智书企飞',
  输入关键字进行过滤: '输入关键字进行过滤',
  输入关键词进行查询: '输入关键词进行查询',
  请输入商机名称或客户名称: '请输入商机名称或客户名称',
  请输入产品名称: '请输入产品名称',
  请输入客户名称搜索报价单: '请输入客户名称搜索报价单',
  请输入客户名称搜索合同: '请输入客户名称搜索合同',
  请输入客户名称搜索订单: '请输入客户名称搜索订单',
  加载中: '加载中',
  负责人: '负责人',
  '暂无数据，请返回上级': '暂无数据，请返回上级',
  参数为必传参数: '参数为必传参数',
  '暂无搜索结果，请更换搜索关键字': '暂无搜索结果，请更换搜索关键字',
  已选: '已选',
  数: '数',
  清空: '清空',
  请选择: '请选择',
  请上传: '请上传',
  '暂无数据，请先选择': '暂无数据，请先选择',
  选择部门: '选择部门',
  提示: '提示',
  确认重置: '确认重置',
  'App Secret重置后会导致历史用户信息失效，请务必二次确认是否继续进行重置操作！': 'App Secret重置后会导致历史用户信息失效，请务必二次确认是否继续进行重置操作！',
  你所选择的: '你所选择的',
  包含下级: '包含下级',
  是否确认选择: '是否确认选择',
  全部: '全部',
  我负责的: '我负责的',
  我协作的: '我协作的',
  我团队负责的: '我团队负责的',
  请输入: '请输入',
  我团队协作的: '我团队协作的',
  最多可选: '最多可选人数是 '
};
